export default __webpack_public_path__ + "static/media/loyaltyIcon.57d65526.svg";